import React, { Component } from "react";
import { message, Row, Col, Table, Tag, Divider, Spin, Tooltip } from "antd";
import { UndoOutlined, NodeIndexOutlined, ArrowRightOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import { ButtonItem, ModalItem, TextAreaItem, round2Decimals, MensajeError } from "../../../../Components/Items";
import { formatearTiempo } from "../OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";

const nombreCompleto = (persona) =>
  persona
    ? [persona.nombre, persona.apellidoPaterno, persona.apellidoMaterno].filter(Boolean).join(" ") || "—"
    : "—";

class TrazabilidadOrdenPU extends Component {
  state = {
    loading: false,
    lotes: [],
    movimientos: [],
    total: 0,
    loteSeleccionado: null,
    cadena: [],
    movimientosLote: [],
    modalCadenaVisible: false,
    modalCancelarVisible: false,
    operacionACancelar: null,
    motivoCancelacion: "",
  };

  componentDidMount() {
    this.cargar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.recargar !== this.props.recargar) this.cargar();
  }

  cargar = () => {
    if (!this.props.ordenId) return;
    this.setState({ loading: true });
    const cuerpo = { ordenId: this.props.ordenId, empresaId: this.props.empresaId };
    Promise.all([
      axios.post("ordenesDeProduccionPU/lotesDeOrden", cuerpo, { headers: this.props.headersToken }),
      axios.post("ordenesDeProduccionPU/timelineOrden", { ...cuerpo, pagina: 1, limite: 200 }, { headers: this.props.headersToken }),
    ])
      .then(([resLotes, resTimeline]) => {
        this.setState({
          loading: false,
          lotes: resLotes.data.success === 2 ? resLotes.data.lotes : [],
          movimientos: resTimeline.data.success === 2 ? resTimeline.data.movimientos : [],
          total: resTimeline.data.total || 0,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al cargar la trazabilidad" });
      });
  };

  verCadena = (lote) => {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/trazabilidadLote",
        { loteId: lote._id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            loteSeleccionado: res.data.lote,
            cadena: res.data.cadena,
            movimientosLote: res.data.movimientos,
            modalCadenaVisible: true,
          });
        } else {
          MensajeError({ message: res.data.error || "No se pudo cargar la trazabilidad del lote" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  abrirCancelar = (operacionId) => this.setState({ modalCancelarVisible: true, operacionACancelar: operacionId, motivoCancelacion: "" });
  cerrarCancelar = () => this.setState({ modalCancelarVisible: false, operacionACancelar: null });

  confirmarCancelar = () => {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/cancelarOperacion",
        {
          operacionId: this.state.operacionACancelar,
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          motivo: this.state.motivoCancelacion,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Movimiento cancelado correctamente");
          this.cerrarCancelar();
          this.cargar();
          if (this.props.onCambio) this.props.onCambio();
        } else {
          MensajeError({ message: res.data.error || "No se pudo cancelar el movimiento" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  operacionMasReciente = () => {
    const vigentes = this.state.movimientos.filter((movimiento) => !movimiento.cancelado);
    return vigentes.length > 0 ? vigentes[0].operacionId : null;
  };

  columnasLotes = () => [
    { title: "Lote", dataIndex: "folio", key: "folio", width: 130 },
    { title: "Piezas", dataIndex: "cantidadPiezas", key: "cantidadPiezas", width: 80, align: "right" },
    {
      title: "Etapa actual",
      key: "etapa",
      render: (_, lote) => (
        <Tag color={lote.etapaActualId?.color || "default"}>{lote.etapaActualId?.nombre || "—"}</Tag>
      ),
    },
    ...(this.props.ocultarCostosOrdenProduccionPU
      ? []
      : [
          {
            title: "Costo unitario",
            dataIndex: "costoUnitarioAcumulado",
            key: "costoUnitarioAcumulado",
            width: 130,
            align: "right",
            render: (valor) => `$ ${round2Decimals(valor || 0)}`,
          },
          {
            title: "Costo total",
            dataIndex: "costoTotal",
            key: "costoTotal",
            width: 130,
            align: "right",
            render: (valor) => `$ ${round2Decimals(valor || 0)}`,
          },
        ]),
    {
      title: "Retrabajos",
      dataIndex: "vecesRetrabajado",
      key: "vecesRetrabajado",
      width: 100,
      align: "center",
      render: (valor) => (valor > 0 ? <Tag color="orange">{valor}</Tag> : "—"),
    },
    { title: "Viene de", dataIndex: "folioOrigen", key: "folioOrigen", width: 130, render: (valor) => valor || "—" },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      width: 110,
      render: (estado) =>
        estado === 1 ? <Tag color="blue">Activo</Tag> : estado === 2 ? <Tag>Dividido</Tag> : <Tag color="green">Cerrado</Tag>,
    },
    {
      title: "",
      key: "acciones",
      width: 60,
      render: (_, lote) => (
        <ButtonItem size="small" cyan icon={<NodeIndexOutlined />} onClick={() => this.verCadena(lote)} />
      ),
    },
  ];

  columnasMovimientos = (operacionCancelable) => [
    {
      title: "Hora de movimiento",
      dataIndex: "fecha",
      key: "fecha",
      width: 150,
      render: (fecha, movimiento) => {
        const desfaseMin = movimiento.fechaRegistro ? Math.round(moment(movimiento.fechaRegistro).diff(moment(fecha), "minutes", true)) : 0;
        return (
          <>
            {moment(fecha).format("DD/MM/YY HH:mm")}
            {this.props.permisoVerTiempoRealVsCapturado && Math.abs(desfaseMin) > 5 && (
              <Tooltip title="Hora en que se capturó en el sistema">
                <div style={{ fontSize: 11, color: "#fa8c16" }}>
                  Registrado {moment(movimiento.fechaRegistro).format("DD/MM HH:mm")} (+{formatearTiempo(desfaseMin, this.props.unidadTiempoProduccion)})
                </div>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: "Lote",
      key: "lote",
      width: 170,
      render: (_, movimiento) =>
        movimiento.loteDestinoId && movimiento.loteDestinoId._id !== movimiento.loteOrigenId?._id ? (
          <>
            {movimiento.loteOrigenId?.folio} <ArrowRightOutlined style={{ fontSize: 10, color: "#999" }} />{" "}
            <b>{movimiento.loteDestinoId.folio}</b>
          </>
        ) : (
          <b>{movimiento.loteOrigenId?.folio || "—"}</b>
        ),
    },
    {
      title: "Movimiento",
      key: "etapas",
      render: (_, movimiento) => (
        <>
          <Tag color={movimiento.etapaOrigenId?.color || "default"}>{movimiento.etapaOrigenId?.nombre || "Inicio"}</Tag>
          <ArrowRightOutlined style={{ fontSize: 10, color: "#999", marginRight: 6 }} />
          <Tag color={movimiento.etapaDestinoId?.color || "default"}>{movimiento.etapaDestinoId?.nombre || "—"}</Tag>
          {movimiento.esRetrabajo && <Tag color="orange">Retrabajo</Tag>}
          {movimiento.altaInventario?.insumoId && (
            <Tag color={movimiento.altaInventario.tipo === "scrap" ? "volcano" : "green"}>
              Alta {movimiento.altaInventario.tipo === "scrap" ? "scrap" : "terminado"}
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Motivo",
      key: "motivoEntrada",
      width: 160,
      render: (_, movimiento) => movimiento.motivoEntradaNombre || "—",
    },
    { title: "Piezas", dataIndex: "cantidad", key: "cantidad", width: 80, align: "right" },
    ...(this.props.ocultarCostosOrdenProduccionPU
      ? []
      : [
          {
            title: "Costo consumido",
            dataIndex: "costoTotalConsumido",
            key: "costoTotalConsumido",
            width: 140,
            align: "right",
            render: (valor) => `$ ${round2Decimals(valor || 0)}`,
          },
        ]),
    { title: "Responsable", key: "responsable", width: 180, render: (_, movimiento) => nombreCompleto(movimiento.responsableId) },
    {
      title: "",
      key: "acciones",
      width: 130,
      render: (_, movimiento) => {
        if (movimiento.cancelado) return <Tag>Cancelado</Tag>;
        if (!this.props.puedeCancelar || movimiento.operacionId !== operacionCancelable) return null;
        return (
          <ButtonItem size="small" rojo icon={<UndoOutlined />} onClick={() => this.abrirCancelar(movimiento.operacionId)}>
            Cancelar
          </ButtonItem>
        );
      },
    },
  ];

  detalleMovimiento = (movimiento) => (
    <div style={{ padding: "4px 8px" }}>
      {movimiento.consumos && movimiento.consumos.length > 0 ? (
        <Table
          size="small"
          pagination={false}
          rowKey={(consumo, indice) => indice}
          dataSource={movimiento.consumos}
          columns={[
            {
              title: "Matriz consumida",
              key: "matriz",
              render: (_, consumo) =>
                `${consumo.matrizId?.clave ? consumo.matrizId.clave + " - " : ""}${consumo.matrizId?.descripcion || consumo.descripcion || "Matriz"}`,
            },
            { title: "Unidades", dataIndex: "unidadesMatriz", key: "unidadesMatriz", width: 100, align: "right" },
            ...(this.props.ocultarCostosOrdenProduccionPU
              ? []
              : [
                  {
                    title: "Costo",
                    dataIndex: "costoTotal",
                    key: "costoTotal",
                    width: 120,
                    align: "right",
                    render: (valor) => `$ ${round2Decimals(valor || 0)}`,
                  },
                ]),
            {
              title: "Insumos descontados",
              key: "componentes",
              render: (_, consumo) => (
                <Table
                  size="small"
                  pagination={false}
                  showHeader={false}
                  rowKey={(componente, indice) => indice}
                  dataSource={consumo.componentes || []}
                  locale={{ emptyText: "Sin insumos" }}
                  columns={[
                    {
                      title: "Insumo",
                      key: "insumo",
                      render: (_, componente) =>
                        `${componente.insumoId?.clave ? componente.insumoId.clave + " - " : ""}${componente.insumoId?.descripcion || "Insumo"}`,
                    },
                    {
                      title: "Cantidad",
                      key: "cantidad",
                      width: 130,
                      align: "right",
                      render: (_, componente) =>
                        `${componente.cantidad}${componente.insumoId?.unidadId?.nombre ? " " + componente.insumoId.unidadId.nombre : ""}`,
                    },
                    ...(this.props.ocultarCostosOrdenProduccionPU
                      ? []
                      : [
                          {
                            title: "Costo unitario",
                            dataIndex: "costoUnitario",
                            key: "costoUnitario",
                            width: 120,
                            align: "right",
                            render: (valor) => `$ ${round2Decimals(valor || 0)}`,
                          },
                          {
                            title: "Costo",
                            key: "costo",
                            width: 110,
                            align: "right",
                            render: (_, componente) => `$ ${round2Decimals((componente.costoUnitario || 0) * (componente.cantidad || 0))}`,
                          },
                        ]),
                  ]}
                />
              ),
            },
          ]}
        />
      ) : (
        <div style={{ color: "#999" }}>Sin consumo de material en esta etapa</div>
      )}

      <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>
        {movimiento.operadorId && <>Operador: {nombreCompleto(movimiento.operadorId)} · </>}
        {movimiento.maquinaria && <>Maquinaria: {movimiento.maquinaria} · </>}
        {movimiento.minutosTrabajo ? <>Tiempo: {formatearTiempo(movimiento.minutosTrabajo, this.props.unidadTiempoProduccion)} · </> : null}
        Piezas buenas: {movimiento.cantidadBuena}
      </div>
      {movimiento.aprobacionCalidad?.aprobadorId && (
        <div style={{ fontSize: 12, color: "#666" }}>
          Calidad: {nombreCompleto(movimiento.aprobacionCalidad.aprobadorId)} — {movimiento.aprobacionCalidad.comentario}
        </div>
      )}
      {movimiento.comentarioEntrada && <div style={{ fontSize: 12, color: "#666" }}>Entrada: {movimiento.comentarioEntrada}</div>}
      {movimiento.observaciones && <div style={{ fontSize: 12, color: "#666" }}>Observaciones: {movimiento.observaciones}</div>}
      {movimiento.altaInventario?.insumoId && (
        <div style={{ fontSize: 12, color: "#666" }}>
          Alta en inventario: {movimiento.altaInventario.insumoId?.clave || movimiento.altaInventario.insumoId?.descripcion} ×{" "}
          {movimiento.altaInventario.cantidad}
          {!this.props.ocultarCostosOrdenProduccionPU && ` @ $ ${round2Decimals(movimiento.altaInventario.costoUnitario || 0)}`}
        </div>
      )}
      {movimiento.cancelado && (
        <div style={{ fontSize: 12, color: "#ff4d4f", marginTop: 4 }}>
          Cancelado el {moment(movimiento.fechaCancelacion).format("DD/MM/YYYY HH:mm")}
          {movimiento.motivoCancelacion ? ` — ${movimiento.motivoCancelacion}` : ""}
        </div>
      )}
    </div>
  );

  render() {
    const { lotes, movimientos } = this.state;
    const operacionReciente = this.operacionMasReciente();

    return (
      <Spin spinning={this.state.loading}>
        <Divider orientation="left" plain style={{ margin: "8px 0" }}>
          Lotes de producción
        </Divider>
        <Table
          size="small"
          pagination={false}
          rowKey="_id"
          scroll={{ x: 1000 }}
          dataSource={lotes}
          columns={this.columnasLotes()}
          locale={{ emptyText: "Todavía no hay lotes en esta orden" }}
        />

        <Divider orientation="left" plain style={{ margin: "24px 0 8px 0" }}>
          Movimientos ({this.state.total})
        </Divider>
        <Table
          size="small"
          pagination={false}
          rowKey="_id"
          scroll={{ x: 1100 }}
          dataSource={movimientos}
          columns={this.columnasMovimientos(operacionReciente)}
          locale={{ emptyText: "Todavía no se han movido piezas" }}
          expandable={{
            expandedRowRender: this.detalleMovimiento,
            rowExpandable: () => true,
          }}
        />

        <ModalItem
          title={`Trazabilidad del lote ${this.state.loteSeleccionado?.folio || ""}`}
          visible={this.state.modalCadenaVisible}
          spinning={this.state.loading}
          onCancel={() => this.setState({ modalCadenaVisible: false })}
          width="70%"
          paddingTop
          footer={null}
        >
          <Row gutter={16} style={{ marginBottom: 12 }}>
            <Col span={24}>
              <b>Cadena de lotes:</b>{" "}
              {this.state.cadena.map((eslabon, indice) => (
                <span key={eslabon._id}>
                  {indice > 0 && " → "}
                  <Tag color={eslabon._id === this.state.loteSeleccionado?._id ? "blue" : "default"}>
                    {eslabon.folio} ({eslabon.cantidadPiezas} pza)
                  </Tag>
                </span>
              ))}
            </Col>
          </Row>
          <Table
            size="small"
            pagination={false}
            rowKey="_id"
            scroll={{ x: 900 }}
            dataSource={this.state.movimientosLote}
            columns={this.columnasMovimientos(null)}
            locale={{ emptyText: "Este lote no tiene movimientos" }}
            expandable={{ expandedRowRender: this.detalleMovimiento, rowExpandable: () => true }}
          />
        </ModalItem>

        <ModalItem
          title="Cancelar movimiento"
          visible={this.state.modalCancelarVisible}
          spinning={this.state.loading}
          onCancel={this.cerrarCancelar}
          width="40%"
          paddingTop
          footer={null}
        >
          <div style={{ color: "#999", fontSize: 12, marginBottom: 12 }}>
            Se devuelve a inventario el material consumido, se deshace el alta del terminado o scrap si la hubo, y los
            lotes vuelven a como estaban. Solo aplica al último movimiento registrado.
          </div>
          <div style={{ marginBottom: 4, fontWeight: 600 }}>Motivo (opcional)</div>
          <TextAreaItem
            placeholder="Opcional"
            value={this.state.motivoCancelacion}
            onChange={(e) => this.setState({ motivoCancelacion: e.target.value })}
          />
          <div style={{ textAlign: "right", marginTop: 16 }}>
            <ButtonItem rojo onClick={this.confirmarCancelar}>
              Cancelar movimiento
            </ButtonItem>
          </div>
        </ModalItem>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
  permisoVerTiempoRealVsCapturado:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6aeb5418c1751c1ba6f45bb6")?.activado,
  ocultarCostosOrdenProduccionPU:
    state.user.tipo !== 0 &&
    !state.user.permisos.find((v) => v.permisoId.toString() === "6aa99cc1341d44e893c47cdd")?.activado,
});

export default connect(mapStateToProps)(TrazabilidadOrdenPU);
